// Select all video elements within elements having the class "background-video"
const videos = document.querySelectorAll(".background-full-video video");
const playButtons = document.querySelectorAll(".background-full-video .icon-play");
const posterImages = document.querySelectorAll(".background-full-video img");

// Function to handle the play event for each video
function playVideo(currentVideo, playButton, posterImage) {
	// Pause all other videos
	videos.forEach((video, index) => {
		if (video !== currentVideo) {
		video.pause();
		video.controls = false;
		playButtons[index].style.display = "flex";
		posterImages[index].style.display = "block";
		video.style.display = "none";
		}
	});

	currentVideo.play();
	currentVideo.controls = true;
	playButton.style.display = "none";
	if(typeof(posterImage) != 'undefined') {
		posterImage.style.display = "none";
	}
	currentVideo.style.display = "block";

	currentVideo.addEventListener("click", preventPause);
	currentVideo.addEventListener("seeking", function (event) {
		if (currentVideo.paused) {
			currentVideo.play();
		}
	});

	currentVideo.addEventListener("pause", function () {
		currentVideo.controls = false;
		playButton.style.display = "flex";
		if(typeof(posterImage) != 'undefined') {
			posterImage.style.display = "block";
		}
		document.querySelectorAll(".vplay").style.display = "block";

		currentVideo.style.display = "none";
	});

	currentVideo.addEventListener("play", function () {
		playButton.style.display = "none";
		if(typeof(posterImage) != 'undefined') {
			posterImage.style.display = "none";
		}
		// if(typeof(currentVideo) != 'undefined') {
			currentVideo.controls = true;
			currentVideo.style.display = "block";
		// }
	});
	}

	// Prevent pause event function
	function preventPause(event) {
	event.preventDefault();
	event.stopPropagation();
	}

	// Loop through each video element and assign event listeners
	videos.forEach((video, index) => {
	const playButton = playButtons[index];
	const posterImage = posterImages[index];

	if (playButton) {
		playButton.addEventListener("click", function () {
		playVideo(video, playButton, posterImage);
		});
	}
});